import axios from './axios';
import type { ProjectMember, PaginationMeta } from '../types/projectMember';

export const fetchProjectMembers = async (
  projectId: string,
  page = 1,
  limit = 15,
  status?: string,
  search?: string,
  role?: string
): Promise<{ data: ProjectMember[]; meta: PaginationMeta }> => {
  const params: Record<string, any> = { page, limit };
  if (status) params.status = status;
  if (search) params.search = search;
  if (role) params.role = role;
  
  const res = await axios.get(`/v1/projects/${projectId}/members`, { params });
  const content = res.data?.content || {};
  
  // Laravel LengthAwarePaginator structure inside response_formatter
  return {
    data: content.data || [],
    meta: {
      current_page: content.current_page || 1,
      last_page: content.last_page || 1,
      per_page: content.per_page || limit,
      total: content.total || 0,
    },
  };
};

export const addProjectMember = async (
  projectId: string,
  payload: {
    name?: string;
    email?: string;
    phone?: string;
    role: string;
    company?: string;
    job_title?: string;
    user_id?: string | number;
    via?: 'email' | 'whatsapp' | string;
  }
) => {
  const res = await axios.post(`/v1/projects/${projectId}/members`, payload);
  return res.data;
};

export const addMemberFromMarketplace = async (
  projectId: string,
  payload: {
    user_id?: string | number;
    email?: string;
    phone?: string;
    role: string;
  }
) => {
  const res = await axios.post(`/v1/projects/${projectId}/members`, payload);
  return res.data;
};

export const fetchAvailableServicemen = async (
  projectId: string,
  search?: string
) => {
  const params: Record<string, any> = {};
  if (search) params.search = search;

  const res = await axios.get(`/v1/projects/${projectId}/available-servicemen`, { params });
  return res.data;
};

export const changeMemberRole = async (
  projectId: string,
  memberId: string,
  role: string
) => {
  const res = await axios.patch(`/v1/projects/${projectId}/members/${memberId}/role`, { role });
  return res.data;
};

export const deactivateMember = async (
  projectId: string,
  memberId: string
) => {
  const res = await axios.post(`/v1/projects/${projectId}/members/${memberId}/deactivate`);
  return res.data;
};

export const restoreMember = async (
  projectId: string,
  memberId: string
) => {
  const res = await axios.post(`/v1/projects/${projectId}/members/${memberId}/activate`);
  return res.data;
};

export const resendInvitation = async (
  projectId: string,
  memberId: string,
  via: 'email' | 'whatsapp' = 'email'
) => {
  const res = await axios.post(`/v1/projects/${projectId}/members/${memberId}/resend`, { via });
  return res.data;
};
